import {Action} from "redux";
import {Project} from "../../domain/model/project";

export enum CustomerDashboardActionType {
    REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST = "CUSTOMER_DASHBOARD_REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST",
    CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST = "CUSTOMER_DASHBOARD_CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST",

}

export interface IRequestGetAllByRecommendProjectListAction extends Action {
    type: CustomerDashboardActionType.REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST;
}

export interface ICallbackGetAllByRecommendProjectListAction extends Action {
    type: CustomerDashboardActionType.CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST;
    isSuccess: boolean;
    item: Project[];
}

export type CustomerDashboardAction =
    IRequestGetAllByRecommendProjectListAction |
    ICallbackGetAllByRecommendProjectListAction ;

export interface ICustomerDashboardActionCreator {
    requestGetAllByRecommendProjectListAction(): IRequestGetAllByRecommendProjectListAction;

    callbackGetAllByRecommendProjectListAction(isSuccess: boolean, item: Project[]): ICallbackGetAllByRecommendProjectListAction;
}

class ActionCreator implements ICustomerDashboardActionCreator {
    public requestGetAllByRecommendProjectListAction = (): IRequestGetAllByRecommendProjectListAction => {
        return {
            type: CustomerDashboardActionType.REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST,
        };
    };

    public callbackGetAllByRecommendProjectListAction = (isSuccess: boolean, item: Project[]): ICallbackGetAllByRecommendProjectListAction => {
        return {
            type: CustomerDashboardActionType.CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST,
            isSuccess,
            item,
        };
    };
}

export const createCustomerDashboardActionCreator = (): ICustomerDashboardActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/customer_dashboard_action.ts